import { combineReducers } from "redux";
import Documents from "./Documents";
import QrCode from "./QrCode";

// main reducers
export const reducers = combineReducers({
  QrCode,
  Documents,
});
